import { AppError, isAppError } from './AppError';

export class InteractionError extends AppError {
    constructor(public readonly originalError: unknown, message: string) {
        super(
            'InteractionError',
            originalError,
            message,
            originalError instanceof Error ? [originalError.message] : [],
            'WARN',
        );
    }
}

export const createInteractionError = (
    originalError: unknown,
    message = `Failed to handle user interaction`,
) => (isAppError(originalError) ? originalError : new InteractionError(originalError, message));
